import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Link } from 'react-router-dom';

const Home = () => {
    return (
        <React.Fragment>
            <section className="section pb-0 hero-section" id="hero">
                <div className="bg-overlay bg-overlay-pattern"></div>
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={8} sm={10}>
                            <div className="text-center mt-lg-5 pt-5">
                                <h1 className="display-6 fw-semibold mb-3 lh-base">AI-Powered Crypto Predictions with <span
                                    className="text-success">ForecastNest </span></h1>
                                <p className="lead text-muted lh-base">Harness multiple premium AI models to forecast Bitcoin, Ethereum, and crypto prices across 4-hour, daily, weekly, monthly, and 180-day timeframes with automated consensus predictions and performance tracking.</p>

                                <div className="d-flex gap-2 justify-content-center mt-4">
                                    <Link to="/register" className="btn btn-primary">Get Started <i className="ri-arrow-right-line align-middle ms-1"></i></Link>
                                    <Link to="/pages-pricing" className="btn btn-danger">View Plans <i className="ri-eye-line align-middle ms-1"></i></Link>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>

            </section>
        </React.Fragment>
    );
};

export default Home;